const api_url = "https://clairity-api-fdo3rxwvya-uc.a.run.app/clairity";

export default api_url;